import React from 'react';
import get from 'lodash/get';

import { Link } from 'libs/router';

import SystemMessageWrapperContext from '../wrapper/context/SystemMessageWrapperContext';

import { __t, applyTranslations } from 'utils/language';
import { FUNC_RETURN_NULL } from 'modules/messenger/components/system/v2/utils/system-message';
import { stripHTML } from 'utils/helper/common';
import { styleOnlySanitizeGenericHtml } from 'utils/sanitize';

import './system-message-payment-details-are-empty.scss';

applyTranslations(require('./system-message-payment-details-are-empty.i18n.json'));

const MSG_KEY = 'system_message_payment_details_are_empty';

const SystemMessagePaymentDetailsAreEmpty = () => {
  const {
    message,
    renderAvatar = FUNC_RETURN_NULL,
    renderDisclaimer = FUNC_RETURN_NULL
  } = React.useContext(SystemMessageWrapperContext);

  const campaignName = get(message, 'metadata.campaignName', '');
  const organizationId = get(message, 'metadata.organizationId', null);

  const renderText = () => {
    const text = __t(`${MSG_KEY}.creator.text`, { campaignName });
    return (
      <div
        className="system-message-payment-details-are-empty__text"
        title={stripHTML(text)}
        dangerouslySetInnerHTML={{ __html: styleOnlySanitizeGenericHtml(text) }}
      />
    );
  };

  const renderLink = () => {
    const text = __t(`${MSG_KEY}.creator.link_text`);
    return (
      <Link
        to={`/organizations/${organizationId}/settings/details`}
        target="_blank"
        className="system-message-payment-details-are-empty__link"
        title={text}
      >
        {text}
      </Link>
    );
  };

  return (
    <React.Fragment>
      {renderAvatar('report-inside-circle-custom-fg')}
      <div className="system-message-payment-details-are-empty">
        {renderText()}
        {renderLink()}
        {renderDisclaimer(__t(`${MSG_KEY}.creator.disclaimer`))}
      </div>
    </React.Fragment>
  );
};

export default SystemMessagePaymentDetailsAreEmpty;
